/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    AsyncUploadStatusAndChangesResponseDTO,
    AsyncUploadStatusAndChangesV2ResponseDTO,
    AsyncUploadStatusByChecksumResponseDTO,
    AsyncUploadStatusByExternalIdResponseDTO,
    GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    GetRequestJobsFilesDedupByJobUuidParams,
    GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    HTTPValidationErrorDTO,
    PostRequestJobsAsyncUploadByJobUuidAndChecksum200,
    PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo,
    PostRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId200,
    PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo,
    PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    PostRequestJobsFilesByJobUuidBodiesTwo,
    PostRequestJobsFilesByJobUuidParams,
    PostRequestJobsFilesDedupByJobUuidParams,
    PostRequestJobsUploadByJobUuid200,
    PostRequestJobsUploadByJobUuidBodiesTwo,
    PostRequestJobsUploadByJobUuidParams,
    UploadResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Upload a file and connect it to the specified job.
- Note when using a mobile API key and uploading a file with a name that
already exists it will have file_name+checksum as filename.
When using a PC client API key the existing file will be overwritten.
- Note when uploading a file that would overwrite an existing path
no FileEvent will be created for the deleted file.

 * @summary Post Sync Upload
 */
export const postRequestJobsFilesByJobUuid = (
    jobUuid: string,
    postRequestJobsFilesByJobUuidBodiesTwo: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>,
    params: PostRequestJobsFilesByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    const formData = new FormData()
    if (postRequestJobsFilesByJobUuidBodiesTwo.file !== undefined) {
        formData.append(`file`, postRequestJobsFilesByJobUuidBodiesTwo.file)
    }

    return customInstance<UploadResponseDTO | void>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
            params: PostRequestJobsFilesByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
        params: PostRequestJobsFilesByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsFilesByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
            params: PostRequestJobsFilesByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsFilesByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsFilesByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>
>
export type PostRequestJobsFilesByJobUuidMutationBody =
    BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
export type PostRequestJobsFilesByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Sync Upload
 */
export const usePostRequestJobsFilesByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
                params: PostRequestJobsFilesByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsFilesByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<PostRequestJobsFilesByJobUuidBodiesTwo>
        params: PostRequestJobsFilesByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Upload a file to cache and schedule it for asynchronous processing. The call returns the file uuid. The endpoint validates user inputs and checksum if it is provided. If the transfer has been interrupted either by the client or due to unstable network, upload should be restarted from beginning.
 * @summary Post Sync Upload With Async Processing
 */
export const postRequestJobsUploadByJobUuid = (
    jobUuid: string,
    postRequestJobsUploadByJobUuidBodiesTwo: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>,
    params: PostRequestJobsUploadByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    const formData = new FormData()
    if (postRequestJobsUploadByJobUuidBodiesTwo.file !== undefined) {
        formData.append(`file`, postRequestJobsUploadByJobUuidBodiesTwo.file)
    }

    return customInstance<PostRequestJobsUploadByJobUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/upload`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsUploadByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
            params: PostRequestJobsUploadByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
        params: PostRequestJobsUploadByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsUploadByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
            params: PostRequestJobsUploadByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsUploadByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsUploadByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>
>
export type PostRequestJobsUploadByJobUuidMutationBody =
    BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
export type PostRequestJobsUploadByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Sync Upload With Async Processing
 */
export const usePostRequestJobsUploadByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
                params: PostRequestJobsUploadByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsUploadByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<PostRequestJobsUploadByJobUuidBodiesTwo>
        params: PostRequestJobsUploadByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsUploadByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Dedup File
 */
export const getRequestJobsFilesDedupByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<UploadResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_dedup`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesDedupByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsFilesDedupByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/files_dedup`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsFilesDedupByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesDedupByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesDedupByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesDedupByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>
>
export type GetRequestJobsFilesDedupByJobUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsFilesDedupByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsFilesDedupByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsFilesDedupByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesDedupByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsFilesDedupByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsFilesDedupByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsFilesDedupByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Dedup File
 */

export function useGetRequestJobsFilesDedupByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesDedupByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesDedupByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsFilesDedupByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Add files to a job with no need to perform the actual upload of the file.
Using the checksum of the file to link the job to an already uploaded
file if Capture contains the file checksum.
- Note when using a mobile API key and uploading a file with a name that
already exists, it will have file_name+checksum as filename.
When using a PC client API key the existing file will be overwritten.
- Note when uploading a file that would overwrite an existing path
no FileEvent will be created for the deleted file.
- Due to some clients that are unable to POST with no data
we also have a GET endpoint but it is not supported.
- If *group_id* is specified, the file will be added to a group.
  One must also provide the *group_type*, and optionally the *master*
  flag, which defaults to 0.

 * @summary Dedup File
 */
export const postRequestJobsFilesDedupByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsFilesDedupByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<UploadResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_dedup`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesDedupByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsFilesDedupByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsFilesDedupByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsFilesDedupByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsFilesDedupByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsFilesDedupByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsFilesDedupByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>
>

export type PostRequestJobsFilesDedupByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Dedup File
 */
export const usePostRequestJobsFilesDedupByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsFilesDedupByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsFilesDedupByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsFilesDedupByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesDedupByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the status of a not yet complete upload
 * @summary Async Upload Check
 */
export const getRequestJobsAsyncUploadByJobUuidAndChecksum = (
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AsyncUploadStatusByChecksumResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/async_upload/${encodeURIComponent(String(checksum))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsAsyncUploadByJobUuidAndChecksumQueryKey = (
    jobUuid?: string,
    checksum?: string,
    params?: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
) => {
    return [
        `/jobs/${jobUuid}/async_upload/${checksum}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsAsyncUploadByJobUuidAndChecksumQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsAsyncUploadByJobUuidAndChecksumQueryKey(
            jobUuid,
            checksum,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
        >
    > = ({ signal }) =>
        getRequestJobsAsyncUploadByJobUuidAndChecksum(
            jobUuid,
            checksum,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && checksum),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsAsyncUploadByJobUuidAndChecksumQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
        >
    >
export type GetRequestJobsAsyncUploadByJobUuidAndChecksumQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsAsyncUploadByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsAsyncUploadByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsAsyncUploadByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Async Upload Check
 */

export function useGetRequestJobsAsyncUploadByJobUuidAndChecksum<
    TData = Awaited<
        ReturnType<typeof getRequestJobsAsyncUploadByJobUuidAndChecksum>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    checksum: string,
    params: GetRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadByJobUuidAndChecksum
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsAsyncUploadByJobUuidAndChecksumQueryOptions(
            jobUuid,
            checksum,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Upload a file and schedule it for asynchronous processing after the transfer has been completed.
The endpoint validates user inputs and verifies the received data against the provided checksum. If the transfer has been interrupted either by the client  or due to unstable network the partial content will still be stored together with the known byte offset. The client can continue to upload the rest of the data by providing the correct offset. Note that the offset is not arbitrary. Discontinuity in the provided offset is not allowed and will be rejected. If the client offset differs the known offset will be returned in the error response.
 * @summary Async Upload File
 */
export const postRequestJobsAsyncUploadByJobUuidAndChecksum = (
    jobUuid: string,
    checksum: string,
    postRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>,
    params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    const formData = new FormData()
    if (
        postRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo.file !==
        undefined
    ) {
        formData.append(
            `file`,
            postRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo.file,
        )
    }

    return customInstance<PostRequestJobsAsyncUploadByJobUuidAndChecksum200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/async_upload/${encodeURIComponent(String(checksum))}`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsAsyncUploadByJobUuidAndChecksumMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadByJobUuidAndChecksum
                >
            >,
            TError,
            {
                jobUuid: string
                checksum: string
                data: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
                params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestJobsAsyncUploadByJobUuidAndChecksum>
        >,
        TError,
        {
            jobUuid: string
            checksum: string
            data: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
            params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams
        },
        TContext
    > => {
        const mutationKey = ['postRequestJobsAsyncUploadByJobUuidAndChecksum']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadByJobUuidAndChecksum
                >
            >,
            {
                jobUuid: string
                checksum: string
                data: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
                params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams
            }
        > = (props) => {
            const { jobUuid, checksum, data, params } = props ?? {}

            return postRequestJobsAsyncUploadByJobUuidAndChecksum(
                jobUuid,
                checksum,
                data,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsAsyncUploadByJobUuidAndChecksumMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestJobsAsyncUploadByJobUuidAndChecksum>
        >
    >
export type PostRequestJobsAsyncUploadByJobUuidAndChecksumMutationBody =
    BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
export type PostRequestJobsAsyncUploadByJobUuidAndChecksumMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Async Upload File
 */
export const usePostRequestJobsAsyncUploadByJobUuidAndChecksum = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadByJobUuidAndChecksum
                >
            >,
            TError,
            {
                jobUuid: string
                checksum: string
                data: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
                params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsAsyncUploadByJobUuidAndChecksum>>,
    TError,
    {
        jobUuid: string
        checksum: string
        data: BodyType<PostRequestJobsAsyncUploadByJobUuidAndChecksumBodiesTwo>
        params: PostRequestJobsAsyncUploadByJobUuidAndChecksumParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsAsyncUploadByJobUuidAndChecksumMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the status of a not yet completed upload for the provided upload id
 * @summary Async Upload With Upload Id Check
 */
export const getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId = (
    jobUuid: string,
    uploadId: string,
    params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AsyncUploadStatusByExternalIdResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/async_upload_with_upload_id/${encodeURIComponent(String(uploadId))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryKey =
    (
        jobUuid?: string,
        uploadId?: string,
        params?: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    ) => {
        return [
            `/jobs/${jobUuid}/async_upload_with_upload_id/${uploadId}`,
            ...(params ? [params] : []),
        ] as const
    }

export const getGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
            >
        >,
        TError = ErrorType<HTTPValidationErrorDTO>,
    >(
        jobUuid: string,
        uploadId: string,
        params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryKey(
                jobUuid,
                uploadId,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                >
            >
        > = ({ signal }) =>
            getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId(
                jobUuid,
                uploadId,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!(jobUuid && uploadId),
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
            >
        >
    >
export type GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
        >
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    uploadId: string,
    params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
        >
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    uploadId: string,
    params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
        >
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    uploadId: string,
    params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Async Upload With Upload Id Check
 */

export function useGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId<
    TData = Awaited<
        ReturnType<
            typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
        >
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    uploadId: string,
    params: GetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdQueryOptions(
            jobUuid,
            uploadId,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Upload a file and schedule it for asynchronous processing after the transfer has been completed.
If the transfer has been interrupted either by the client or due to unstable network the partial
content will still be stored together with the known byte offset. The client can continue to
upload the rest of the data by providing the correct offset. Note that the offset is not
arbitrary. Discontinuity in the provided offset is not allowed and will be rejected. If the
client offset differs the known offset will be returned in the error response.
 * @summary Async Upload File With Upload Id
 */
export const postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId = (
    jobUuid: string,
    uploadId: string,
    postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>,
    params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    const formData = new FormData()
    if (
        postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo.file !==
        undefined
    ) {
        formData.append(
            `file`,
            postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo.file,
        )
    }

    return customInstance<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/async_upload_with_upload_id/${encodeURIComponent(String(uploadId))}`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                >
            >,
            TError,
            {
                jobUuid: string
                uploadId: string
                data: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
                params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
            >
        >,
        TError,
        {
            jobUuid: string
            uploadId: string
            data: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
            params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                >
            >,
            {
                jobUuid: string
                uploadId: string
                data: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
                params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams
            }
        > = (props) => {
            const { jobUuid, uploadId, data, params } = props ?? {}

            return postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId(
                jobUuid,
                uploadId,
                data,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
            >
        >
    >
export type PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdMutationBody =
    BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
export type PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Async Upload File With Upload Id
 */
export const usePostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
                >
            >,
            TError,
            {
                jobUuid: string
                uploadId: string
                data: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
                params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<
            typeof postRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadId
        >
    >,
    TError,
    {
        jobUuid: string
        uploadId: string
        data: BodyType<PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdBodiesTwo>
        params: PostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsAsyncUploadWithUploadIdByJobUuidAndUploadIdMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the status of a not yet complete uploads together with changes

 * @summary Changes And Async Upload Status
 */
export const getRequestJobsChangesAndAsyncUploadStatusByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AsyncUploadStatusAndChangesResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/changes_and_async_upload_status`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/changes_and_async_upload_status`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
            >
        >,
        TError = ErrorType<HTTPValidationErrorDTO>,
    >(
        jobUuid: string,
        params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryKey(
                jobUuid,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                >
            >
        > = ({ signal }) =>
            getRequestJobsChangesAndAsyncUploadStatusByJobUuid(
                jobUuid,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!jobUuid,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
            >
        >
    >
export type GetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Changes And Async Upload Status
 */

export function useGetRequestJobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsChangesAndAsyncUploadStatusByJobUuidQueryOptions(
            jobUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Get the changes and the status of the asynchronous uploads for the job.

The response contains the changes since the provided serial `since` together with the
statuses of the not yet completed asynchronous uploads.
 * @summary Changes And Async Upload Status V2
 */
export const getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid = (
    jobUuid: string,
    params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AsyncUploadStatusAndChangesV2ResponseDTO>(
        {
            url: `/v2/jobs/${encodeURIComponent(String(jobUuid))}/changes_and_async_upload_status`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
) => {
    return [
        `/v2/jobs/${jobUuid}/changes_and_async_upload_status`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
            >
        >,
        TError = ErrorType<HTTPValidationErrorDTO>,
    >(
        jobUuid: string,
        params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryKey(
                jobUuid,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                >
            >
        > = ({ signal }) =>
            getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid(
                jobUuid,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!jobUuid,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
            >
        >
    >
export type GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Changes And Async Upload Status V2
 */

export function useGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuid<
    TData = Awaited<
        ReturnType<typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestV2JobsChangesAndAsyncUploadStatusByJobUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestV2JobsChangesAndAsyncUploadStatusByJobUuidQueryOptions(
            jobUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
